import React from "react";
import {NavBar} from "./components/NavBar";
import {BasisGrid12, BasisGrid23} from "./components/BasisGrids";
import {PipelineList} from "./components/PipelineList";
import CreateNewPipeline from "./components/CreateNewPipeline";
import PasswordReset from "./components/PasswordReset";
import {PipelineInstance} from "./components/PipelineInstance";
import {getPipelineInstance} from "./rest";
import FileManager from "./components/FileManager";
import {diff} from "radash";
import Login from "./components/Login";

export const routes = ({routeOverrides}) => {

    if(!routeOverrides) {
        routeOverrides = []
    }

    const builtInRoutes = [
        {
            path: "/pipelines",
            element: <>
                <NavBar/>
                <BasisGrid23>
                    <PipelineList showOnly={"all"}/>
                </BasisGrid23>
            </>,
            children: []
        },
        {
            path: "/pipelines/not-ready",
            element: <>
                <NavBar/>
                <BasisGrid23>
                    <PipelineList showOnly={"not-ready"}/>
                </BasisGrid23>
            </>,
            children: []
        },
        {
            path: "/pipelines/running",
            element: <>
                <NavBar/>
                <BasisGrid23>
                    <PipelineList showOnly={"running"}/>
                </BasisGrid23>
            </>,
            children: []
        },
        {
            path: "/pipelines/stopped",
            element: <>
                <NavBar/>
                <BasisGrid23>
                    <PipelineList showOnly={"stopped"}/>
                </BasisGrid23>
             </>,
            children: []
        },
        {
            path: "/pipelines/createNew",
            element:<>
                <NavBar/>
                <BasisGrid12>
                    <CreateNewPipeline/>
                </BasisGrid12>
             </>
            ,
            children: []
        },
        {
            path: "/",
                element: <>
                    <NavBar/>
                    <BasisGrid23>
                        <PipelineList showOnly={"all"}/>
                    </BasisGrid23>
                </>
            ,
            children: []
        },
        {
            path: "/login",
            element: <Login/>
        },
        {
            path: "/pwreset/:guid",
            element: <>
                <NavBar/>
                <div style={{marginTop: 100}}></div>
                <PasswordReset/>
            </>
        },
        {
            path: "/pipelines/*",
            element: <>
                <NavBar/>
                <BasisGrid12>
                    <PipelineInstance/>
                </BasisGrid12>
             </>,
            loader: async ({params}) => {
                 return getPipelineInstance(`/${params["*"]}`).then(res => res.json())
            }
        },
        {
            path: "/pipelineFiles/*",
            element: <>
                <NavBar/>
                <BasisGrid12>
                    <FileManager/>
                </BasisGrid12>
             </>
            ,
            loader: async ({params}) => `/${params["*"]}`
        },
        {
            path: "/globusAuthCallback",
            element: <div>...loading</div>
        }
    ].map(r => {
        const o = routeOverrides.find(o => o.path === r.path)
        return o || r
    })

    const newRoutes = diff(
        routeOverrides.map(o => o.path),
        builtInRoutes.map(r => r.path)
    ).map(path => {

        const r = routeOverrides.find(o => o.path === path)
        if(!r) {
            throw `expected route for ${path}, found none`
        }
        return r
    })

    return [...builtInRoutes, ...newRoutes]
}